import { AccountAvailableActions } from "@varsity/services";
import { Ticket } from "../tickets/tickets.model";

export class SiteLayout {
    BodyStyleColor?: string;
    ClientID?: number;
    MainBar1Color?: string;
    MainBar1FontColor?: string;
    MainBar2Color?: string;
    MainBar2FontColor?: string;
    TeamLogo?: string;
    HeaderImage?: string;
    ShowHeaderLogo?: boolean;
}

export class EventsSearchResult {
    AddOnDescription?: string;
    Area?: string;
    ClienID?: number;
    ClientIP?: string;
    DBName?: string;
    Description?: string;
    Distance?: number;
    EndSellingDate?: string;
    EventDate?: string;
    EventID?: number;
    EventTime?: string;
    FreeFormLine1?: string;
    FreeFormLine2?: string;
    HoldID?: number;
    HomeTeam?: string;
    ISOCurrencyCode?: string;
    ImageMap?: string;
    Opponent?: string;
    PriceRange?: string;
    PromoCode?: string;
    ReDirectURL?: string;
    Self?: string;
    ServerDate?: string;
    Special?: string;
    Special2?: string;
    Special2NoWeb?: string;
    Special3?: string;
    Special3NoWeb?: string;
    SponsorID?: number;
    SponsorName?: string;
    SponsorWebName?: string;
    Sport?: string;
    StartSellingDate?: any;
    TicketCount?: number;
    TicketsAvailable?: number;
    TrackingID?: number;
    VenueName?: string;
    WebSalesEnd?: string;
    WebSalesStart?: string;
    sitelayout?: SiteLayout;
    accountActions?: AccountAvailableActions;
}

export class Merchandise {
    AmtPerTicket?: number;
    DisplayValue?: number;
    Category?: string;
    Description?: string;
    DisplayFlag?: boolean;
    DisplayMessage?: string;
    EventID?: number;
    ISOCurrencyCode?: string;
    MaxQtyAmt?: number;
    MinQtyAmt?: number;
    NewRenewSales?: boolean;
    OptOrMandatory?: number;
    OrderAmtQty?: number;
    OrderType?: number;
    OutOfStateTax?: number;
    PLU?: string;
    PPorNTI?: number;
    PPorNTIID?: number;
    PricePointID?: number;
    RaffleID?: number;
    SelectedFlag?: boolean;
    SortOrder?: number;
    SponsorID?: number;
    StateTax?: number;
    SubscriptionBeginClaimHrs?: number;
    SubscriptionBegins?: string;
    SubscriptionEnds?: string;
    SubscriptionGroup?: string;
    WebCC?: number;
    ntiTickets: Ticket[];
}

export class InstituteSearchResult {
    AccountNumber?: number;
    Address1?: string;
    Address2?: string;
    City?: string;
    ClientID?: number;
    ClientName?: string;
    ContactEmailAddress?: string;
    Country?: string;
    DBName?: string;
    ESTAdjustment?: number;
    EventIDs?: number[];
    FreeFormLine1?: string;
    LastEventDate?: string;
    Phone?: number;
    ReleaseDate?: string;
    SelectSeatEnabled?: boolean;
    ServerDate?: string;
    SponsorID?: number;
    State?: string;
    TRCategory?: string;
    TRSport?: string;
    VenueName?: string;
    WebDesc?: string;
    WebSalesStart?: string;
    Zip?: string;
    sitelayout?: SiteLayout;
}


export class TeamEvent {
    EventID?: number;
    EventDate?: string;
    EventTime?: string;
    WebSalesStart?: string;
    ClientID?: number;
    ServerDate?: string;
    StartSellingDate?: string;
    EndSellingDate?: string;
    WebSalesEnd?: string;
    PromoCode?: string;
    ImageMap?: string;
    Description?: string;
    PriceRange?: string
    VenueName?: string;
    Sport?: string;
    SportIcon?: string;
    TicketsAvailable?: number;
    AvailableCount?: number;
    Distance?: number;
    Area?: string;
    DBName?: string;
    ClientIP?: string;
    ReDirectUrl?: string;
    SponsorID?: number;
    SponsorName: string;
    SponsorWebName: string;
    HomeTeam: string;
    Opponent: string;
    FreeFormLine1: string;
    FreeFormLine2: string;
    Special: string;
    SpecialNoWeb: string;
    Special2: string;
    Special2NoWeb: string;
    Special3: string;
    Special3NoWeb: string;
    TicketCount: number;
    HoldID: number;
    AddOnDescription: string;
    TrackingID: string;
    ISOCurrencyCode: string;
    Self: string;
    sitelayout?: SiteLayout;
    accountActions?: AccountAvailableActions;
    GatesClosedFlag?: boolean;
    GateValidationOnly?: boolean;
    GateValidationText?: string;
    EventPassedFlag?: boolean;
    SeasonPassIDs?: string;
}

export class TeamEventsInfo {
    sitelayout?: SiteLayout;
    TeamHeader?: string;
    EventListing?: TeamEvent[];
    RedirectURL?: string;
    ResultFlag?: boolean;
    ResultMessage?: string;
    DisplayPromoFlag?: boolean;
    DisplayMessage?: string;
}

export class EventInfo {
    eventInfo: TeamEvent;
    eventInfoViewType: string | null;
}




export class EventsTest {
    SuccessFlag: boolean;
    Token: string;
}



// WEBPACK FOOTER //
// ./src/services/events/events.model.ts